import { useQuery, useQueryClient } from '@tanstack/react-query'
import React from 'react'
import { listOrg as listOrgAPI } from 'services/apiOrg';

const useListOrg = (page=1,size=10,searchTerm) => {
  
    const queryClient = useQueryClient();

    const{isPending, isSuccess, isError, error, data}=useQuery({
        queryKey: ['orgList',page,size,searchTerm],
        queryFn:()=> listOrgAPI(page,size,searchTerm),
        keepPreviousData:true,
        staleTime:  2 * 60 * 60 * 1000
    })

    return{isPending, isSuccess, isError, error, data}
}

export default useListOrg